export default __webpack_public_path__ + "static/media/2.11a7c186.png";